// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__1ntrh","footerRight":"styles_footerRight__6OM9W"};